import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { Rarity } from '@sorare/core/src/__generated__/globalTypes';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { useQuery } from '@sorare/core/src/hooks/graphql/useQuery';

import type {
  RarityVaultHowItWorksDialogQuery,
  RarityVaultHowItWorksDialogQueryVariables,
} from './__generated__/index.withFetch.graphql.ts';
import { RarityVaultHowItWorksDialog } from './index.tsx';

const query = gql`
  query RarityVaultHowItWorksDialogQuery($rarity: Rarity!, $sport: Sport!) {
    config {
      id
      sealingConfig(sport: $sport) {
        ...RarityVaultHowItWorksDialog_sealingConfig
      }
    }
  }
  ${RarityVaultHowItWorksDialog.fragments.sealingConfig}
` as TypedDocumentNode<
  RarityVaultHowItWorksDialogQuery,
  RarityVaultHowItWorksDialogQueryVariables
>;

type Props = {
  open?: boolean;
  onClose: () => void;
  rarity?: Rarity;
};

export const RarityVaultHowItWorksDialogWithFetch = ({
  open = false,
  onClose,
  rarity = Rarity.limited,
}: Props) => {
  const { sport } = useSportContext();
  const { data, loading } = useQuery(query, {
    fetchPolicy: 'cache-first',
    skip: !open,
    variables: {
      rarity,
      sport,
    },
  });

  const sealingConfig = data?.config?.sealingConfig;

  if (!open) {
    return null;
  }

  return (
    <RarityVaultHowItWorksDialog
      open={Boolean(open && data)}
      loading={loading}
      onClose={onClose}
      sealingConfig={sealingConfig}
      rarity={rarity}
    />
  );
};
